import Home from './Home.jsx';
import LettersCount from './LettersCount.jsx';
import MultipleChart from './MultipleChart.jsx';
import CircleChart from './CircleChart.jsx';
import LettersTable from './LettersTable.jsx';
import Page403 from './Page403.jsx';
import Help from './Help.jsx';
import Card from './Card.jsx';

export {
  Home,
  LettersCount,
  MultipleChart,
  CircleChart,
  LettersTable,
  Page403,
  Help,
  Card
}


// WEBPACK FOOTER //
// ./src/components/modules/home/index.js